module.exports = __webpack_public_path__ + "advantages3_fr_CA.jpg";